import React from "react";
import { Col, Row, Card, CardBody } from "reactstrap";
import { Bar, Line } from "react-chartjs-2";
import { useSelector } from "react-redux";
import { getStyle } from "@coreui/coreui/dist/js/coreui-utilities";
import { CustomTooltips } from "@coreui/coreui-plugin-chartjs-custom-tooltips";
import moment from "moment-jalaali";
import SataticData from "./staticData.json";

// const brandPrimary = getStyle("--primary");
// const brandSuccess = getStyle("--success");
const brandInfo = getStyle("--info");
// const brandWarning = getStyle("--warning");
// const brandDanger = getStyle("--danger");

const ChartWidget = ({ incomeCardChart, productionCardChart }) => {
  // console.log(data , "is widget data")
  // console.log(moment(new Date()).locale("fa").format("ddd") , 'is date of chart wodget');
  //   const [card1, setCard1] = useState();
  //   const [card2, setCard2] = useState();

  //   const [card4, setCard4] = useState();
  const lang_choiced = useSelector((state) => state.lang_change);
  // const dispatch = useDispatch();

  // Card Chart 2
  const productionCardChartData = {
    labels: SataticData.chartWidget.productionCardChartData.labels,
    datasets: [
      {
        label:
          SataticData.chartWidget.productionCardChartData.datasets[0].label,
        backgroundColor: brandInfo,
        borderColor: "rgba(255,255,255,.55)",
        data: productionCardChart.datasets,
      },
    ],
  };
  const incomeCardChartData = {
    tooltips: {
      enabled: false,
      custom: CustomTooltips,
    },
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    scales: {
      xAxes: [
        {
          gridLines: {
            color: "transparent",
            zeroLineColor: "transparent",
          },
          ticks: {
            fontSize: 2,
            fontColor: "transparent",
          },
        },
      ],
      yAxes: [
        {
          display: false,
          ticks: {
            display: false,
            min: Math.min.apply(Math, productionCardChart.datasets) - 5,
            max: Math.max.apply(Math, productionCardChart.datasets) + 5,
          },
        },
      ],
    },
    elements: {
      line: {
        tension: 0.00001,
        borderWidth: 1,
      },
      point: {
        radius: 4,
        hitRadius: 10,
        hoverRadius: 4,
      },
    },
  };

  // Card Chart 4
  const cardChartData4 = {
    labels: SataticData.chartWidget.incomeCardChartData.labels,
    datasets: [
      {
        label: SataticData.chartWidget.incomeCardChartData.datasets[0].label,
        backgroundColor: "rgba(255,255,255,.3)",
        borderColor: "transparent",
        data: incomeCardChart.datasets,
      },
    ],
  };

  const cardChartOpts4 = {
    tooltips: {
      enabled: false,
      custom: CustomTooltips,
    },
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    scales: {
      xAxes: [
        {
          display: false,
          barPercentage: 0.6,
        },
      ],
      yAxes: [
        {
          display: false,
        },
      ],
    },
  };
  return (
    <Row>
      <Col
        xs={12}
        sm={6}
        md={6}
        xl={12}
        lg={12}
        style={{ height: "auto", width: "100%" }}
      >
        <Card
          className="border-radius-15 text-white bg-info"
          style={{ height: "280px", width: "100%", direction: "ltr" }}
        >
          <CardBody className="pb-0" style={{ fontFamily: "BRoya" }}>
            <div className="text-value">{productionCardChart.title_value}</div>
            <div>
              {
                // data.productionCardChartData.title_prod
              }
              تولید ماهانه
            </div>
          </CardBody>
          <div className="chart-wrapper mx-3" style={{ height: "70px" }}>
            <Line
              data={productionCardChartData}
              options={incomeCardChartData}
              height={70}
            />
          </div>
        </Card>
      </Col>
      <Col
        xs={12}
        sm={6}
        md={6}
        xl={12}
        lg={12}
        style={{ height: "auto", width: "100%" }}
      >
        <Card
          className="border-radius-15 text-white bg-danger"
          style={{ height: "270px", width: "100%" }}
        >
          <CardBody className="pb-0" style={{ fontFamily: "BRoya" }}>
            <div className="text-value">{incomeCardChart.title_value}</div>
            <div>
              {
                // data.incomeCardChartData.title_prod
              }
              درآمد ماهانه
            </div>
          </CardBody>
          <div className="chart-wrapper mx-3" style={{ height: "70px" }}>
            <Bar data={cardChartData4} options={cardChartOpts4} height={70} />
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default ChartWidget;
